<template>
  <div class="gsr" :class="{ 'is-lit': lit, 'is-landing': landing }" data-testid="gift-star" role="status">
    <!-- The gift-of-the-day star (mystic-page 2026-10-29, PNGs 19/20): a daily
         row in the claim row's style. Its 25 ✦ is collected with the built
         Claim, so it has no button. Never "earn", "points" or "reward". -->
    <span class="gsr-star" aria-hidden="true">
      <svg viewBox="0 0 40 40">
        <g v-if="landing" class="gsr-rays"><line v-for="i in 12" :key="i" x1="20" y1="20" :x2="20 + 19 * Math.cos(i * Math.PI / 6)" :y2="20 + 19 * Math.sin(i * Math.PI / 6)" /></g>
        <path class="gsr-glyph" d="M20 4 L23.2 16.8 L36 20 L23.2 23.2 L20 36 L16.8 23.2 L4 20 L16.8 16.8 Z" />
      </svg>
    </span>
    <span class="gsr-text">
      <span class="gsr-title">{{ star.title }}</span>
      <span class="gsr-line">{{ star.line }}<template v-if="lit && star.carats">{{ ' ' }}<b class="gsr-amt">✦ {{ star.carats }}</b></template></span>
    </span>
    <span v-if="landing && star.carats" class="gsr-rise" data-testid="gift-star-rise" aria-hidden="true">+✦ {{ star.carats }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  // { state: 'waiting' | 'lit' | 'claimed', carats, title, line, litAt } (utils/quest-sky giftStarOf)
  star: { type: Object, required: true },
  landing: { type: Boolean, default: false },
})
const lit = computed(() => props.star.state === 'lit' || props.star.state === 'claimed')
</script>

<style scoped>
.gsr { position: relative; display: flex; align-items: center; gap: 12px; margin-bottom: 10px; padding: 8px 12px; border-radius: 12px;
  border: 1px solid rgba(201,169,78,.35); background: rgba(20,8,40,.72); color: #e6dafa; }
.gsr-star { flex: 0 0 auto; width: 30px; height: 30px; display: flex; }
.gsr-star svg { width: 100%; height: 100%; overflow: visible; }
.gsr-glyph { fill: none; stroke: #b9a6d6; stroke-width: 1.4; stroke-linejoin: round; }
.gsr-text { display: flex; flex-direction: column; min-width: 0; }
.gsr-title { font: 600 13px Cinzel, serif; letter-spacing: .12em; text-transform: uppercase; color: #f0d9a3; }
.gsr-line { font: 14px/1.3 'Inter', system-ui, sans-serif; color: #f3eaff; }
.gsr-amt { font-weight: 700; color: #ffe7b5; white-space: nowrap; }
.is-lit { border-color: rgba(240,217,163,.65); background: radial-gradient(120% 140% at 0% 50%, rgba(240,217,163,.14), rgba(20,8,40,.72) 60%); }
.is-lit .gsr-glyph { fill: #ffe7b5; stroke: #ffe7b5; filter: drop-shadow(0 0 6px rgba(255,231,181,.8)); }
/* The landing: the star ignites with a short ray burst, and +✦ 25 rises toward the Claim. */
.is-landing .gsr-glyph { animation: gsr-ignite 1.1s cubic-bezier(.2,.8,.2,1) both; transform-origin: 20px 20px; }
.gsr-rays line { stroke: #ffe7b5; stroke-width: 1.2; stroke-linecap: round; opacity: 0; animation: gsr-rays 1s ease-out .15s both; }
.gsr-rise { position: absolute; right: 14px; top: 2px; font: 600 15px Cinzel, serif; color: #ffe7b5; text-shadow: 0 0 10px rgba(255,231,181,.7);
  pointer-events: none; animation: gsr-rise 1.6s cubic-bezier(.2,.8,.2,1) .3s both; }
@keyframes gsr-ignite { 0% { transform: scale(.6); fill: transparent; } 55% { transform: scale(1.35); } 100% { transform: scale(1); } }
@keyframes gsr-rays { 0% { opacity: 0; stroke-dasharray: 0 40; } 40% { opacity: 1; } 100% { opacity: 0; stroke-dasharray: 19 40; } }
@keyframes gsr-rise { 0% { opacity: 0; transform: translateY(6px); } 25% { opacity: 1; } 100% { opacity: 0; transform: translateY(-34px); } }
@media (prefers-reduced-motion: reduce) {
  .is-landing .gsr-glyph, .gsr-rays line, .gsr-rise { animation: none; }
  .gsr-rise, .gsr-rays { display: none; }
}
</style>
